(() => {
  const init = (root) => {
    if (!root || root.dataset.depthReady) return;
    root.dataset.depthReady = 'true';
    const guide = root.querySelector('[data-depth-knife-guide]');
    if (guide) {
      const bar = guide.querySelector('[data-depth-knife-tabs]');
      const panels = [...guide.querySelectorAll('[data-depth-knife-panel]')];
      bar.setAttribute('role', 'tablist');
      const tabs = panels.map((panel, index) => {
        const tab = document.createElement('button');
        tab.type = 'button'; tab.className = 'syk-depth-knife-tab';
        tab.textContent = panel.dataset.knifeLabel;
        tab.id = `SykDepthKnifeTab-${root.dataset.depthProduct}-${index}`;
        panel.id = `SykDepthKnifePanel-${root.dataset.depthProduct}-${index}`;
        tab.setAttribute('role', 'tab'); tab.setAttribute('aria-controls', panel.id);
        panel.setAttribute('role', 'tabpanel'); panel.setAttribute('aria-labelledby', tab.id);
        panel.tabIndex = 0;
        bar.append(tab);
        return tab;
      });
      const choose = (index, focus = false) => {
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
        });
        if (focus) { tabs[index].focus(); tabs[index].scrollIntoView({block:'nearest',inline:'nearest'}); }
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => choose(index));
        tab.addEventListener('keydown', (event) => {
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else return;
          event.preventDefault(); choose(next, true);
        });
      });
      choose(0);
    }
    const dialog = root.querySelector('[data-depth-dialog]');
    let zoomSource;
    if (dialog) {
      const image = dialog.querySelector('img');
      root.querySelectorAll('[data-depth-zoom]').forEach(button => button.addEventListener('click', () => {
        zoomSource = button; image.src = button.dataset.depthZoom;
        image.alt = button.querySelector('img')?.alt || 'Product detail'; dialog.showModal();
      }));
      dialog.querySelector('button').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } });
      dialog.addEventListener('close', () => zoomSource?.focus());
    }
    const highlights = root.querySelector('[data-depth-review-highlights]');
    const widget = root.querySelector('.syk-depth-review-widget');
    if (highlights && widget) {
      let lastSignature = '';
      const syncReviews = () => {
        const rows = [...widget.querySelectorAll('.jdgm-rev')].slice(0, 3).map(review => ({
          body: review.querySelector('.jdgm-rev__body')?.textContent.trim(),
          author: review.querySelector('.jdgm-rev__author')?.textContent.trim(),
          date: review.querySelector('.jdgm-rev__timestamp')?.textContent.trim(),
          rating: review.querySelector('.jdgm-rev__rating')?.getAttribute('data-score')
        })).filter(row => row.body && row.author);
        const signature = JSON.stringify(rows); if (signature === lastSignature) return;
        lastSignature = signature; highlights.replaceChildren(); highlights.hidden = !rows.length;
        rows.forEach(row => {
          const article = document.createElement('article'); article.className = 'syk-depth-review-highlight';
          const rating = document.createElement('span'); rating.textContent = row.rating ? `${row.rating}-star product review` : 'Product review';
          const quote = document.createElement('blockquote'); const body = document.createElement('p');
          body.textContent = `“${row.body.length > 250 ? row.body.slice(0,247).trimEnd() + '…' : row.body}”`; quote.append(body);
          const footer = document.createElement('footer'); footer.textContent = [row.author, row.date, `${root.dataset.depthReviewLabel || 'Foldable set'} · excerpt from review below`].filter(Boolean).join(' · ');
          article.append(rating, quote, footer); highlights.append(article);
        });
      };
      syncReviews();
      const observer = new MutationObserver(syncReviews);
      observer.observe(widget, {subtree:true,childList:true,characterData:true});
      root.addEventListener('syk:dispose', () => observer.disconnect(), {once:true});
    }
  };
  document.querySelectorAll('[data-depth-story]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-depth-story]').forEach(init));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-depth-story]').forEach(root => root.dispatchEvent(new Event('syk:dispose'))));
})();
